// * React Hooks
import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

// * Routes
import * as URL from "./Routes";
import ProtectedRoute from "src/helpers/ProtectedRoute";
import CreateBatch from "src/views/pages/ManageCandidates";
import ManageBatch from "src/views/pages/ManageBatch";
import ViewCandidates from "src/views/pages/ViewCandidates"

// * Pages
const Login = lazy(() => import("../views/pages/Login/Login"));
const Register = lazy(() => import("../views/pages/register/Register"));
const Page404 = lazy(() => import("../views/pages/page404/Page404"));
const Page505 = lazy(() => import("../views/pages/page500/Page500"));
const Dashboard = lazy(() => import("../views/dashboard/Dashboard"));

const Templates = lazy(() => import("../views/pages/Templates/Templates"));
const GenerateCertificates = lazy(() => import("../views/pages/GenerateCertificates/GenerateCertificates"));
const DownloadCertifcates = lazy(() => import("../views/pages/DownloadCertifcates/DownloadCertificates"));
const AddTemplates = lazy(() => import("../views/pages/Templates/AddTemplate/AddTemplate"));
const ApiCirtificate = lazy(()=> import("../views/pages/CandidateList"))
const ApiTemplate = lazy(()=> import("../views/pages/ApiTemplate/TemplateList/Index"))
const AddapiTemplate = lazy(()=> import("../views/pages/ApiTemplate/AddApiTemplate/Index"))
const GenerateApiCertificate = lazy(()=> import("../views/pages/ApiTemplate/GenerateApiCertificate/Index"))
const Event = lazy(() => import("../views/pages/Event/Event"));
const UserCertificates = lazy(() => import("../views/pages/UserCertificates/UserCertificates"));



// * Page Layout Component
const Layout = lazy(() => import("../layout/Layout"));

// * Loader
const Loader = () => (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

export default function Router() {
  const Navigate = useNavigate();
  useEffect(() => {
    if (window.location.pathname === "/") Navigate("/login");
  });
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route
          path={URL.Login}
          element={
            <ProtectedRoute accessBy="non-authenticated">
              <Login />
             </ProtectedRoute>
          }
        />
        <Route
          path={URL.Dashboard}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<Dashboard />} />
             </ProtectedRoute>
          }
        />
        <Route
          path={URL.Templates}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<Templates />} />
             </ProtectedRoute>
          }
        />
        <Route
          path={URL.GenrateCertificates}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<GenerateCertificates />} />
             </ProtectedRoute>
          }
        />
        <Route
          path={URL.DownloadCertificates}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<DownloadCertifcates />} />
            </ProtectedRoute>
          }
        />
        <Route
          path={URL.AddTemplates}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<AddTemplates />} />
             </ProtectedRoute>
          }
        />

        <Route
          path={URL.Event}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<Event />} />
             </ProtectedRoute>
          }
        />



        <Route
          path={URL.CreateBatch}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<CreateBatch />} />
             </ProtectedRoute>
          }
        />
          <Route
          path={URL.ApiCirtificate}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<ApiCirtificate/>} />
             </ProtectedRoute>
          }
        />
          <Route
          path={URL.ManageBatch}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<ManageBatch />} />
             </ProtectedRoute>
          }
        />
          <Route
          path={URL.apiTemplate}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<ApiTemplate />} />
             </ProtectedRoute>
          }
        />
          <Route
          path={URL.addApiTemplate}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<AddapiTemplate />} />
             </ProtectedRoute>
          }
        />
          <Route
          path={URL.generateApiCertificate}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<GenerateApiCertificate />} />
             </ProtectedRoute>
          }
        />
          <Route
          path={URL.viewCandidates}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<ViewCandidates />} />
             </ProtectedRoute>
          }
        />
        <Route
          path={URL.UserCertificates}
          element={
            <ProtectedRoute accessBy="authenticated">
              <Layout component={<UserCertificates />} />
             </ProtectedRoute>
          }
        />
        <Route path={URL.Register} element={<Register />} />
        <Route path={URL.Page500} element={<Page505 />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </Suspense>
  );
}
